import { PageHeader, Form, Col, Row, Button, notification } from "antd";
import { useEffect, useState } from "react";

import IconContactUs from "../../static/icon/IconContactUs";
import { Label } from "reactstrap";
import { FormOutlined } from "@ant-design/icons";
import ActionModal from "./ActionModal";
import { useAuth } from "../../context/auth";

const ContactUs = () => {
  const { accessToken } = useAuth();

  const [form] = Form.useForm();

  const [visible, setVisible] = useState(false);
  const [modalType, setModalType] = useState("");
  const [editRecord, setEditRecord] = useState({});

  const [contactUs, setContactUs] = useState([]);
  const [phone, setPhone] = useState("");

  // let user = JSON.parse(localStorage.getItem("userLogin"));
  //const userId = user[0].userPoolId

  const getContactUs = async () => {
    const url = new URL('/api/contact-us', window.location);

    const res = await fetch(url, {
      headers: { 'X-ACCESS-TOKEN': accessToken },
    });
    if (res.ok) {
      const { contactUs } = await res.json();
      setContactUs(contactUs);
      setPhone(contactUs.phone);
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }
  };

  useEffect(() => {
    getContactUs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //var str = contactUs.phone
  // var test = phone.substring(0, 3);
  // console.log(".substring(0, 2)", test);
  return (
    <>
      {/* {console.log("downlord", downlord)} */}
      <div className="flex justify-between items-center mt-2">
        {/* <Prompt when={formIsHalfFilledOut} message="Are you sure?" /> */}
        <PageHeader
          style={{ padding: 0, width: "100%" }}
          title={
            <span className="flex items-center mt-2">
              <IconContactUs /> &nbsp;&nbsp;Contact Us
            </span>
          }
        />
      </div>
      <div className="content">
        <Row gutter={20} className="mt-1">
          <Col sm={21} md={21} lg={21}></Col>
          <Col sm={2} md={2} lg={2}>
            <Button
              className="mt-2 flex items-center uppercase"
              icon={<FormOutlined />}
              type="primary"
              shape="round"
              style={{
                width: 85,
                paddingLeft: 20,
                color: "#247CB3 ",
                backgroundColor: "#FFFFFF",
              }}
              onClick={() => {
                //   OnEdit();
                setModalType("Edit Note");
                setVisible(true);
                setEditRecord(contactUs);
              }}
            >
              Edit
            </Button>
          </Col>
        </Row>
        <div className="search">
          <Form
            form={form}
            className="search_inline row m-auto w-3/4 py-6"
            onFieldsChange={(_, allFields) => {
              if (allFields.length > 0) {
                // setChange(true);
              }
            }}
          >
            <Row gutter={40} style={{ marginTop: 30, marginBottom: 30 }}>
              <Col sm={12} md={12} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label={
                    <>
                      <div>
                        <span
                          style={{ display: "inline-grid", marginTop: "5px" }}
                        >
                          <svg
                            width="20"
                            height="16"
                            viewBox="0 0 20 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V13C0 13.7956 0.316071 14.5587 0.87868 15.1213C1.44129 15.6839 2.20435 16 3 16H17C17.7956 16 18.5587 15.6839 19.1213 15.1213C19.6839 14.5587 20 13.7956 20 13V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM17 2L10.5 6.47C10.348 6.55777 10.1755 6.60397 10 6.60397C9.82446 6.60397 9.65202 6.55777 9.5 6.47L3 2H17Z"
                              fill="#247CB3"
                            />
                          </svg>
                        </span>
                      </div>
                      <div> &nbsp;&nbsp;Email Support:</div>
                    </>
                  }
                  colon={false}
                  name="category"
                  style={{ fontWeight: 900 }}
                >
                  <Label
                    className="hover:opacity-80 cursor-pointer"
                    onClick={() =>
                      (window.location.href = `mailto:${contactUs.email}`)
                    }
                  >
                    <span
                      style={{
                        marginLeft: 25,
                        color: "#2F80ED",
                        position: "absolute",
                      }}
                    >
                      {contactUs.email}
                    </span>
                  </Label>
                </Form.Item>
              </Col>
              <Col sm={12} md={12} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label={
                    <>
                      <div>
                        <span
                          style={{ display: "inline-grid", marginTop: "5px" }}
                        >
                          <svg
                            width="15"
                            height="20"
                            viewBox="0 0 15 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.77201 0.43881L3.84801 0.0948098C4.85801 -0.22719 5.93501 0.29381 6.36801 1.31181L7.22701 3.33981C7.60101 4.22281 7.39401 5.26181 6.71301 5.90781L4.81901 7.70581C4.93501 8.78181 5.29701 9.84081 5.90301 10.8828C6.47879 11.891 7.25104 12.7734 8.17401 13.4778L10.449 12.7178C11.312 12.4308 12.251 12.7618 12.779 13.5388L14.012 15.3488C14.627 16.2528 14.517 17.4988 13.754 18.2648L12.936 19.0858C12.122 19.9028 10.959 20.1998 9.88401 19.8638C7.34501 19.0718 5.01101 16.7208 2.88101 12.8108C0.748009 8.89481 -0.00499091 5.57081 0.623009 2.84281C0.887009 1.69481 1.70401 0.77981 2.77201 0.43881Z"
                              fill="#247CB3"
                            />
                          </svg>
                        </span>
                      </div>
                      <div> &nbsp;&nbsp;Call Center:</div>
                    </>
                  }
                  colon={false}
                  name="message"
                >
                  <Label>
                    <span style={{ marginLeft: 25, position: "absolute" }}>
                      {phone.substring(0, 2) +
                        "-" +
                        phone.substring(2, 5) +
                        "-" +
                        phone.substring(5, 10)}
                    </span>
                  </Label>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={40} style={{ marginTop: 25, marginBottom: 30 }}>
              <Col sm={12} md={12} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label={
                    <>
                      <div>
                        <span
                          style={{ display: "inline-grid", marginTop: "5px" }}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="12" cy="12" r="12" fill="#3975EA" />
                            <path
                              d="M13.5601 8.66001H14.5001V7.07001C14.0449 7.02269 13.5876 6.99932 13.1301 7.00001C11.7701 7.00001 10.8401 7.83001 10.8401 9.35001V10.66H9.30505V12.44H10.8401V17H12.6801V12.44H14.2101L14.4401 10.66H12.6801V9.52502C12.6801 9.00002 12.8201 8.66001 13.5601 8.66001Z"
                              fill="white"
                            />
                          </svg>
                        </span>
                      </div>
                      <div> &nbsp;&nbsp;Facebook:</div>
                    </>
                  }
                  colon={false}
                  name="category"
                  style={{ fontWeight: 900 }}
                >
                  <a
                    // className="hover:opacity-80 cursor-pointer"
                    href={
                      contactUs.facebook
                        ? "https://www.facebook.com/" + contactUs.facebook
                        : "https://www.facebook.com/"
                    }
                    target="_blank"
                    rel="noreferrer"
                  // onClick={() =>
                  //   (window.location = "mailto:onionevcharger@gmail.com")
                  // }
                  >
                    <span
                      style={{
                        marginLeft: 25,
                        color: "#2F80ED",
                        position: "absolute",
                      }}
                    >
                      {contactUs.facebook ? contactUs.facebook : "-"}
                    </span>
                  </a>
                </Form.Item>
              </Col>
              <Col sm={12} md={12} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label={
                    <>
                      <div>
                        <span
                          style={{ display: "inline-grid", marginTop: "5px" }}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="12"
                              fill="url(#paint0_linear_19623_112674)"
                            />
                            <mask
                              id="mask0_19623_112674"
                              //   style="mask-type:alpha"
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="24"
                              height="24"
                            >
                              <circle
                                cx="12"
                                cy="12"
                                r="12"
                                fill="url(#paint1_linear_19623_112674)"
                              />
                            </mask>
                            <g mask="url(#mask0_19623_112674)">
                              <g filter="url(#filter0_f_19623_112674)">
                                <path
                                  fillRule="evenodd"
                                  clip-rule="evenodd"
                                  d="M0.384521 15.0249C2.33087 11.4365 6.13091 9 10.5 9C16.2793 9 21.0629 13.2631 21.8776 18.8161C19.7123 21.9481 16.0958 24 12 24C6.41748 24 1.72528 20.1879 0.384521 15.0249Z"
                                  fill="url(#paint2_radial_19623_112674)"
                                />
                              </g>
                            </g>
                            <g clip-path="url(#clip0_19623_112674)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.35462 5.62187C10.0389 5.59037 10.257 5.58337 12 5.58337C13.743 5.58337 13.9612 5.59096 14.6449 5.62187C15.3285 5.65279 15.7952 5.76187 16.2035 5.91996C16.6311 6.08154 17.019 6.33412 17.3399 6.66079C17.6665 6.98104 17.9185 7.36837 18.0795 7.79654C18.2382 8.20487 18.3467 8.67154 18.3782 9.35404C18.4097 10.0395 18.4167 10.2576 18.4167 12C18.4167 13.743 18.4091 13.9612 18.3782 14.6455C18.3473 15.328 18.2382 15.7946 18.0795 16.203C17.9185 16.6312 17.6661 17.0192 17.3399 17.3399C17.019 17.6665 16.6311 17.9185 16.2035 18.0795C15.7952 18.2382 15.3285 18.3467 14.646 18.3782C13.9612 18.4097 13.743 18.4167 12 18.4167C10.257 18.4167 10.0389 18.4091 9.35462 18.3782C8.67212 18.3473 8.20546 18.2382 7.79712 18.0795C7.36891 17.9185 6.98094 17.6661 6.66021 17.3399C6.33376 17.0194 6.08114 16.6316 5.91996 16.2035C5.76187 15.7952 5.65337 15.3285 5.62187 14.646C5.59037 13.9606 5.58337 13.7425 5.58337 12C5.58337 10.257 5.59096 10.0389 5.62187 9.35521C5.65279 8.67154 5.76187 8.20487 5.91996 7.79654C6.08138 7.36842 6.33419 6.98064 6.66079 6.66021C6.98106 6.33383 7.36865 6.08122 7.79654 5.91996C8.20487 5.76187 8.67154 5.65337 9.35404 5.62187H9.35462ZM14.593 6.77687C13.9163 6.74596 13.7133 6.73954 12 6.73954C10.2868 6.73954 10.0838 6.74596 9.40712 6.77687C8.78121 6.80546 8.44171 6.90987 8.21537 6.99796C7.91612 7.11462 7.70204 7.25287 7.47746 7.47746C7.26457 7.68457 7.10073 7.93671 6.99796 8.21537C6.90987 8.44171 6.80546 8.78121 6.77687 9.40712C6.74596 10.0838 6.73954 10.2868 6.73954 12C6.73954 13.7133 6.74596 13.9163 6.77687 14.593C6.80546 15.2189 6.90987 15.5584 6.99796 15.7847C7.10062 16.063 7.26454 16.3155 7.47746 16.5226C7.68454 16.7355 7.93712 16.8995 8.21537 17.0021C8.44171 17.0902 8.78121 17.1946 9.40712 17.2232C10.0838 17.2541 10.2862 17.2605 12 17.2605C13.7139 17.2605 13.9163 17.2541 14.593 17.2232C15.2189 17.1946 15.5584 17.0902 15.7847 17.0021C16.084 16.8855 16.298 16.7472 16.5226 16.5226C16.7355 16.3155 16.8995 16.063 17.0021 15.7847C17.0902 15.5584 17.1946 15.2189 17.2232 14.593C17.2541 13.9163 17.2605 13.7133 17.2605 12C17.2605 10.2868 17.2541 10.0838 17.2232 9.40712C17.1946 8.78121 17.0902 8.44171 17.0021 8.21537C16.8855 7.91612 16.7472 7.70204 16.5226 7.47746C16.3155 7.26458 16.0634 7.10075 15.7847 6.99796C15.5584 6.90987 15.2189 6.80546 14.593 6.77687ZM11.1805 13.9781C11.6382 14.1687 12.1478 14.1944 12.6224 14.0509C13.097 13.9074 13.507 13.6036 13.7825 13.1913C14.0579 12.7791 14.1817 12.284 14.1327 11.7907C14.0837 11.2973 13.865 10.8363 13.5138 10.4863C13.2899 10.2626 13.0192 10.0913 12.7212 9.98471C12.4232 9.87815 12.1053 9.839 11.7903 9.87007C11.4754 9.90113 11.1712 10.0016 10.8998 10.1644C10.6283 10.3271 10.3963 10.548 10.2205 10.8111C10.0446 11.0743 9.92932 11.3731 9.88284 11.6862C9.83637 11.9992 9.85988 12.3187 9.95169 12.6216C10.0435 12.9245 10.2013 13.2032 10.4138 13.4378C10.6263 13.6724 10.8881 13.8569 11.1805 13.9781ZM9.66787 9.66787C9.97414 9.36161 10.3377 9.11867 10.7379 8.95292C11.138 8.78717 11.5669 8.70186 12 8.70186C12.4332 8.70186 12.862 8.78717 13.2622 8.95292C13.6624 9.11867 14.0259 9.36161 14.3322 9.66787C14.6385 9.97414 14.8814 10.3377 15.0472 10.7379C15.2129 11.138 15.2982 11.5669 15.2982 12C15.2982 12.4332 15.2129 12.862 15.0472 13.2622C14.8814 13.6624 14.6385 14.0259 14.3322 14.3322C13.7137 14.9507 12.8748 15.2982 12 15.2982C11.1253 15.2982 10.2864 14.9507 9.66787 14.3322C9.04934 13.7137 8.70186 12.8748 8.70186 12C8.70186 11.1253 9.04934 10.2864 9.66787 9.66787ZM16.0297 9.19304C16.1056 9.12145 16.1664 9.03535 16.2084 8.93986C16.2504 8.84436 16.2728 8.74141 16.2744 8.63708C16.2759 8.53276 16.2565 8.42919 16.2172 8.33251C16.178 8.23583 16.1198 8.14801 16.046 8.07423C15.9722 8.00045 15.8844 7.94223 15.7877 7.90301C15.6911 7.86379 15.5875 7.84436 15.4832 7.84588C15.3788 7.8474 15.2759 7.86984 15.1804 7.91186C15.0849 7.95389 14.9988 8.01465 14.9272 8.09054C14.788 8.23814 14.7117 8.43419 14.7147 8.63708C14.7177 8.83997 14.7996 9.03372 14.943 9.1772C15.0865 9.32068 15.2803 9.40259 15.4832 9.40555C15.6861 9.40851 15.8821 9.33228 16.0297 9.19304Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <filter
                                id="filter0_f_19623_112674"
                                x="-3.61548"
                                y="5"
                                width="29.4932"
                                height="23"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                />
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="BackgroundImageFix"
                                  result="shape"
                                />
                                <feGaussianBlur
                                  stdDeviation="2"
                                  result="effect1_foregroundBlur_19623_112674"
                                />
                              </filter>
                              <linearGradient
                                id="paint0_linear_19623_112674"
                                x1="5"
                                y1="1"
                                x2="22.5"
                                y2="27.5"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stop-color="#4464CA" />
                                <stop offset="0.333333" stop-color="#B638A0" />
                                <stop offset="1" stop-color="#D03A9C" />
                              </linearGradient>
                              <linearGradient
                                id="paint1_linear_19623_112674"
                                x1="5"
                                y1="1"
                                x2="22.5"
                                y2="27.5"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stop-color="#4464CA" />
                                <stop offset="0.333333" stop-color="#B638A0" />
                                <stop offset="1" stop-color="#D03A9C" />
                              </linearGradient>
                              <radialGradient
                                id="paint2_radial_19623_112674"
                                cx="0"
                                cy="0"
                                r="1"
                                gradientUnits="userSpaceOnUse"
                                gradientTransform="translate(9.21381 19.5) rotate(90) scale(9.5 8.5)"
                              >
                                <stop stop-color="#FFD653" />
                                <stop offset="0.885417" stop-color="#F9504C" />
                                <stop offset="1" stop-color="#F54E52" />
                              </radialGradient>
                              <clipPath id="clip0_19623_112674">
                                <rect
                                  width="14"
                                  height="14"
                                  fill="white"
                                  transform="translate(5 5)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </div>
                      <div> &nbsp;&nbsp;Instagram:</div>
                    </>
                  }
                  colon={false}
                  name="category"
                  style={{ fontWeight: 900 }}
                >
                  <a
                    // className="hover:opacity-80 cursor-pointer"
                    href={
                      contactUs.instagram
                        ? "https://www.instagram.com/" + contactUs.instagram
                        : "https://www.instagram.com/"
                    }
                    target="_blank"
                    rel="noreferrer"
                  // className="hover:opacity-80 cursor-pointer"
                  // onClick={() =>
                  //   (window.location = "mailto:onionevcharger@gmail.com")
                  // }
                  >
                    <span
                      style={{
                        marginLeft: 25,
                        color: "#2F80ED",
                        position: "absolute",
                      }}
                    >
                      {contactUs.instagram ? contactUs.instagram : "-"}
                    </span>
                  </a>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={40} style={{ marginTop: 25, marginBottom: 30 }}>
              <Col sm={12} md={12} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label={
                    <>
                      <div>
                        <span
                          style={{ display: "inline-grid", marginTop: "5px" }}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="12" cy="12" r="12" fill="#20C92F" />
                            <g clip-path="url(#clip0_19623_112646)">
                              <path
                                d="M12 5C16.411 5 20 7.912 20 11.492C20 12.925 19.445 14.215 18.285 15.486C16.607 17.418 12.854 19.771 12 20.131C11.17 20.481 11.266 19.934 11.304 19.718L11.307 19.7L11.421 19.015C11.448 18.811 11.476 18.494 11.395 18.292C11.305 18.069 10.951 17.953 10.691 17.897C6.846 17.39 4 14.701 4 11.492C4 7.912 7.59 5 12 5ZM9.022 12.686H7.497V9.918C7.497 9.8768 7.4807 9.83727 7.45166 9.80804C7.42262 9.77882 7.3832 9.76226 7.342 9.762H6.78C6.75951 9.762 6.73923 9.76604 6.7203 9.77387C6.70137 9.78171 6.68418 9.79321 6.66969 9.80769C6.65521 9.82218 6.64371 9.83937 6.63587 9.8583C6.62804 9.87723 6.624 9.89751 6.624 9.918V13.404C6.624 13.445 6.641 13.484 6.668 13.511V13.512L6.67 13.514L6.672 13.516C6.701 13.5439 6.73976 13.5593 6.78 13.559H9.022C9.108 13.559 9.177 13.489 9.177 13.403V12.843C9.17713 12.8225 9.17323 12.8022 9.16551 12.7832C9.15779 12.7642 9.14641 12.747 9.13202 12.7324C9.11762 12.7178 9.1005 12.7062 9.08162 12.6983C9.06275 12.6903 9.04249 12.6861 9.022 12.686ZM9.813 9.762C9.77163 9.762 9.73195 9.77844 9.70269 9.80769C9.67344 9.83695 9.657 9.87663 9.657 9.918V13.404C9.657 13.49 9.727 13.559 9.813 13.559H10.375C10.461 13.559 10.53 13.489 10.53 13.404V9.918C10.53 9.8768 10.5137 9.83727 10.4847 9.80804C10.4556 9.77882 10.4162 9.76226 10.375 9.762H9.813ZM13.676 9.762C13.6346 9.762 13.5949 9.77844 13.5657 9.80769C13.5364 9.83695 13.52 9.87663 13.52 9.918V11.988L11.923 9.832C11.919 9.82675 11.9146 9.82174 11.91 9.817V9.816C11.9068 9.8125 11.9035 9.80916 11.9 9.806L11.897 9.803C11.8936 9.79972 11.8899 9.79671 11.886 9.794H11.885L11.88 9.79L11.877 9.788C11.8754 9.78683 11.8738 9.78583 11.872 9.785L11.864 9.78H11.862L11.859 9.778L11.849 9.774L11.845 9.772C11.8417 9.77081 11.8384 9.76981 11.835 9.769H11.833L11.83 9.768L11.821 9.766H11.815L11.812 9.765H11.808L11.806 9.764H11.232C11.1908 9.764 11.1513 9.7803 11.122 9.80934C11.0928 9.83838 11.0763 9.8778 11.076 9.919V13.405C11.076 13.491 11.146 13.56 11.232 13.56H11.792C11.879 13.56 11.949 13.49 11.949 13.405V11.335L13.549 13.495C13.5596 13.5099 13.5728 13.5228 13.588 13.533L13.589 13.534L13.599 13.54L13.603 13.542C13.6056 13.5435 13.6082 13.5448 13.611 13.546L13.618 13.549L13.623 13.551C13.6263 13.5521 13.6296 13.5531 13.633 13.554H13.636C13.649 13.5577 13.6625 13.5598 13.676 13.56H14.236C14.323 13.56 14.393 13.49 14.393 13.405V9.918C14.393 9.87663 14.3766 9.83695 14.3473 9.80769C14.3181 9.77844 14.2784 9.762 14.237 9.762H13.676ZM17.491 10.479V9.919C17.4911 9.89851 17.4872 9.8782 17.4795 9.85922C17.4718 9.84025 17.4604 9.82298 17.446 9.8084C17.4316 9.79382 17.4145 9.78222 17.3956 9.77426C17.3767 9.7663 17.3565 9.76213 17.336 9.762H15.094C15.0536 9.76205 15.0149 9.77783 14.986 9.806H14.985L14.984 9.808L14.982 9.811C14.9541 9.83965 14.9383 9.87799 14.938 9.918V13.404C14.938 13.445 14.955 13.484 14.982 13.511L14.984 13.514L14.986 13.516C15.0151 13.5438 15.0538 13.5592 15.094 13.559H17.336C17.422 13.559 17.491 13.489 17.491 13.403V12.843C17.4911 12.8225 17.4872 12.8022 17.4795 12.7832C17.4718 12.7642 17.4604 12.747 17.446 12.7324C17.4316 12.7178 17.4145 12.7062 17.3956 12.6983C17.3767 12.6903 17.3565 12.6861 17.336 12.686H15.81V12.097H17.335C17.421 12.097 17.49 12.027 17.49 11.941V11.381C17.4901 11.3605 17.4862 11.3402 17.4785 11.3212C17.4708 11.3022 17.4594 11.285 17.445 11.2704C17.4306 11.2558 17.4135 11.2442 17.3946 11.2363C17.3757 11.2283 17.3555 11.2241 17.335 11.224H15.81V10.635H17.335C17.421 10.635 17.49 10.565 17.49 10.479H17.491Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_19623_112646">
                                <rect
                                  width="16"
                                  height="16"
                                  fill="white"
                                  transform="translate(4 4)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </div>
                      <div> &nbsp;&nbsp;LINE:</div>
                    </>
                  }
                  colon={false}
                  name="category"
                  style={{ fontWeight: 900 }}
                >
                  <a
                    href={contactUs.line ? contactUs.line : ""}
                    target="_blank"
                    rel="noreferrer"
                  // className="hover:opacity-80 cursor-pointer"
                  // onClick={() =>
                  //   (window.location = "mailto:onionevcharger@gmail.com")
                  // }
                  >
                    <span
                      style={{
                        marginLeft: 25,
                        color: "#2F80ED",
                        position: "absolute",
                      }}
                    >
                      {contactUs.line ? contactUs.line : "-"}
                    </span>
                  </a>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={40} style={{ marginTop: 25, marginBottom: 150 }}>
              <Col sm={24} md={24} lg={16} style={{ marginRight: "auto" }}>
                <Form.Item
                  label={
                    <>
                      <div>
                        <span
                          style={{ display: "inline-grid", marginTop: "5px" }}
                        >
                          <svg
                            width="22"
                            height="24"
                            viewBox="0 0 22 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20.9375 7.5C21.2469 7.5 21.5 7.24687 21.5 6.9375V5.0625C21.5 4.75313 21.2469 4.5 20.9375 4.5H20V2.25C20 1.00781 18.9922 0 17.75 0H2.75C1.50781 0 0.5 1.00781 0.5 2.25V21.75C0.5 22.9922 1.50781 24 2.75 24H17.75C18.9922 24 20 22.9922 20 21.75V19.5H20.9375C21.2469 19.5 21.5 19.2469 21.5 18.9375V17.0625C21.5 16.7531 21.2469 16.5 20.9375 16.5H20V13.5H20.9375C21.2469 13.5 21.5 13.2469 21.5 12.9375V11.0625C21.5 10.7531 21.2469 10.5 20.9375 10.5H20V7.5H20.9375ZM10.25 6C11.9047 6 13.25 7.34531 13.25 9C13.25 10.6547 11.9047 12 10.25 12C8.59531 12 7.25 10.6547 7.25 9C7.25 7.34531 8.59531 6 10.25 6ZM15.5 17.1C15.5 17.5969 15.0312 18 14.45 18H6.05C5.46875 18 5 17.5969 5 17.1V16.2C5 14.7094 6.41094 13.5 8.15 13.5H8.38437C8.96094 13.7391 9.58906 13.875 10.25 13.875C10.9109 13.875 11.5437 13.7391 12.1156 13.5H12.35C14.0891 13.5 15.5 14.7094 15.5 16.2V17.1Z"
                              fill="#247CB3"
                            />
                          </svg>
                        </span>
                      </div>
                      <div>&nbsp;&nbsp;Address:</div>
                    </>
                  }
                  colon={false}
                  name="address"
                >
                  <Label>
                    <span style={{ marginLeft: 25, position: "absolute" }}>
                      {contactUs?.address
                        ?.replace("จำกัด", "จำกัด \n")
                        .split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key}>
                              {item}
                              <br />
                            </span>
                          );
                        })}
                    </span>
                  </Label>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={40} style={{ marginTop: 25, marginBottom: 150 }}>
              <Col sm={12} md={12} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label="Min Version (Android)"
                  colon={false}
                  name="minVersionAndroid"
                  style={{ fontWeight: 900 }}
                >
                  {contactUs.minVersionAndroid}
                </Form.Item>
              </Col>
              <Col sm={12} md={12} lg={12} style={{ marginRight: "auto" }}>
                <Form.Item
                  label="Min Version (iOS)"
                  colon={false}
                  name="minVersionIOS"
                  style={{ fontWeight: 900 }}
                >
                  {contactUs.minVersionIOS}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <ActionModal
        onOk={() => {
          setVisible(false);
          setEditRecord({});
          getContactUs();
        }}
        visible={visible}
        onCancel={() => {
          setVisible(false);
          setEditRecord({});
          getContactUs();
        }}
        modalType={modalType}
        editRecord={editRecord}
      />
    </>
  );
};

export default ContactUs;
